module.exports = __webpack_public_path__ + "969bf891f201fb3badc7a6312d8fac5d.svg";